import { CancelCashOutRequestEntity, CancelCashOutResponseEntity } from '@shared/core/entities';


export abstract class CancelCashOutRepository {

  abstract cancelTransaction(params: CancelCashOutRequestEntity): Promise<CancelCashOutResponseEntity>;

}
